<div class="app">
    <div class="app__holder">
        <ng-content></ng-content>
    </div>
</div>
